const specs = {
  width: 620,
  title: {
    update: 'pages.materials.modal.update.single.title',
    create: 'pages.materials.modal.create.single.title'
  },
  okText: {
    update: 'pages.materials.modal.update.single.okText',
    create: 'pages.materials.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.materials.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.materials.fields.name.title',
        required: 'pages.materials.fields.name.requiredMessage',
        placeholder: 'pages.materials.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
